import { Component, DestroyRef, Input, OnInit } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { FormControl } from '@angular/forms'
import { BehaviorSubject } from 'rxjs'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { Flags, FlagStorageService } from '../core/services/flag-storage.service'
import { Router } from '@angular/router'

@Component({
  selector: 'app-mfa-warning',
  templateUrl: './mfa-warning.component.html',
  styleUrls: ['./mfa-warning.component.scss']
})
export class MfaWarningComponent implements OnInit {
  @Input() dismissable = true;

  protected stopMfaReminder = new FormControl<boolean>(false);
  private showStopMfaReminderWarningSubject = new BehaviorSubject<boolean>(false);
  protected readonly showStopMfaReminderWarning$ = this.showStopMfaReminderWarningSubject.asObservable();

  constructor(private readonly activeModal: NgbActiveModal,
              private readonly flagStorageService: FlagStorageService,
              private readonly router: Router,
              private readonly destroyRef: DestroyRef) {
  }

  ngOnInit(): void {
    this.stopMfaReminder.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(value => {
        this.showStopMfaReminderWarningSubject.next(value);
        this.flagStorageService.set(Flags.MFA_WARNING_DISMISSED_FOREVER, value);
      });
  }

  enableMfa(): void {
    this.dismiss();
    this.router.navigateByUrl('/portal/profile/mfa');
  }

  dismiss(): void {
    this.flagStorageService.set(Flags.MFA_WARNING_DISMISSED, true);
    this.activeModal.dismiss();
  }

}
